export default __webpack_public_path__ + "static/images/jennie_07.png";